import RangeManager from './KonvaManager/Range/manager'

const KonvaBusinessPlugin = {
    install(Vue) {
        Vue.rangeManager = Vue.prototype.$rangeManager = new RangeManager()
    },
}

export default KonvaBusinessPlugin
